import { useForm } from "react-hook-form"
import { useParams } from "react-router-dom"
import PageTemplate from "./PageTemplate"
import RecoveryPage from "./Recovery";

export default function AuthPage() {

  type formValues = {
    email: string;
    password: string;
    agree?: boolean
  }

  const params = useParams()

  const {
    register: signInRegister,
    handleSubmit: handleSubmitSignIn,
    control: signInControl,
    formState: { isValid: signInValid }
  } = useForm<formValues>({
    defaultValues: {
      email: "",
      password: ""
    }
  })

  const {
    register: signUpRegister,
    handleSubmit: handleSubmitSignUp,
    control: signUpControl,
    formState: { isValid: signUpValid }
  } = useForm<formValues>({
    defaultValues: {
      email: "",
      password: ""
    }
  })

  async function onSubmit(data: any) {
    console.log(data);
  }

  return (
    <>
      {params.page === "sign-in" &&
        <PageTemplate
          title="Sign in"
          control={signInControl}
          bottomText="Dont have a account?"
          bottomLink="/auth/sign-up"
          formParams={{ handleSubmitSignIn, onSubmit, signInRegister }}
        />
      }
      {params.page === "sign-up" &&
        <PageTemplate
          title="Sign up"
          control={signUpControl}
          bottomText="Already registred?"
          bottomLink="/auth/sign-in"
          formParams={{ handleSubmitSignUp, onSubmit, signUpRegister }}
        />
      }
      {params.page === "recovery" &&
        <RecoveryPage />
      }
    </>
  )
}